var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99984 4.66669C1.26346 4.66669 0.666504 5.26364 0.666504 6.00002V11.3334C0.666504 12.0697 1.26346 12.6667 1.99984 12.6667H13.9998C14.7362 12.6667 15.3332 12.0697 15.3332 11.3334V6.00002C15.3332 5.26364 14.7362 4.66669 13.9998 4.66669H1.99984ZM3.39705 10.0066L2.96523 11.3334H1.64705L3.65558 5.51517H5.2408L7.24649 11.3334H5.9283L5.49649 10.0066H3.39705ZM4.42546 6.84472L3.70955 9.04642H5.18683L4.47092 6.84472H4.42546ZM9.01688 11.3334H7.78677V5.51517H10.0822C11.4032 5.51517 12.1675 6.33051 12.1675 7.48676C12.1675 8.64869 11.389 9.44699 10.051 9.44699H9.01688V11.3334ZM9.01688 6.52085V8.46119H9.85211C10.5567 8.46119 10.9004 8.06347 10.9004 7.48676C10.9004 6.90722 10.5567 6.52085 9.84643 6.52085H9.01688ZM12.8065 5.51517H14.0366V11.3334H12.8065V5.51517Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "97120/static/media/API.c795b7670fd51cbcd0c566adafe49699.svg";
export { ForwardRef as ReactComponent };